import React from "react";
import { Col, Container, Row, Tabs, Tab } from "react-bootstrap";

function Technologygcc({ rtl }) {
  const className = rtl
    ? "tekrevol_gray_bg tabing_section  p-100 rtl-style"
    : "tekrevol_gray_bg tabing_section  p-100";
  return (
    <div className={className}>
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6}>
            <h2>
              مجموعة تقنيات TekRevol لتطوير تطبيقات الهاتف المحمول في المملكة
              العربية السعودية
            </h2>
          </Col>
          <Col xs={12} md={6} lg={6}>
            <p>
              كوننا من بين أفضل شركات تطوير تطبيقات الأجهزة المحمولة في المملكة
              العربية السعودية، فإننا نستخدم أحدث التقنيات لتصميم حلول التطبيقات
              بدقة لتلبية المتطلبات الفريدة لمشروعك. سواء كنت تتصور تطوير تطبيق
              لنظام آي أو إس أو اندرويد، فإن خبرتنا الشاملة تمتد عبر جميع
              المنصات والمهارات لإنشاء تطبيقات استثنائية لعملك. وفي الوقت نفسه،
              يضمن نهجنا المبني على منهجيات رشيقة رحلة تطوير مستمرة ومنسقة
            </p>
          </Col>
        </Row>
        <Row>
          <Tabs defaultActiveKey="1" id="uncontrolled-tab-example">
            <Tab eventKey="1" title="الواجهة الأمامية للجوال">
              <ul>
                <li>React Native</li>
                <li>Flutter</li>
                <li>Swift (iOS)</li>
                <li>Kotlin (Android)</li>
              </ul>
            </Tab>
            <Tab eventKey="2" title="أدوات/أطر عمل/مجموعات تطوير البرمجيات">
              <ul>
                <li>Firebase</li>
                <li>Redux</li>
                <li>Alamofire (iOS)</li>
                <li>Retrofit (Android)</li>
              </ul>
            </Tab>
            <Tab eventKey="3" title="نظام التشغيل">
              <ul>
                <li>iOS</li>
                <li>Android</li>
              </ul>
            </Tab>
            <Tab eventKey="4" title="المنصات">
              <ul>
                <li>App Store (iOS)</li>
                <li>Google Play (Android)</li>
              </ul>
            </Tab>
            <Tab eventKey="5" title="آخرون">
              <ul>
                <li>Git</li>
                <li>RESTful APIs</li>
                <li>JSON</li>
                <li>Gradle (Android)</li>
                <li>Xcode (iOS)</li>
                <li> Android Studio (Android)</li>
              </ul>
            </Tab>
          </Tabs>
        </Row>
      </Container>
    </div>
  );
}

export default Technologygcc;
